import { Box } from '@chakra-ui/layout'
import { } from 'containers'
import JsBarcode from 'jsbarcode'
import { connectNetwork } from 'lib/NetworkProvider'
import { routes } from 'lib/routes'
import moment from 'momentconfig'
import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import ReactToPrint from 'react-to-print'
import { Button, Icon, Modal, Table } from 'semantic-ui-react'
import SummarySheet from '../job/SummarySheet'
import { mapOrdToOrdering } from '../lib/util'
import MaterialDropdown from '../utility/MaterialDropdown'

const { app, materials, materialEdit } = routes

class Material extends Component {
    constructor(props) {
        super(props)

        let { onCostChange, material } = props

        this.state = {
            deleting: false,
            ...material,
            materialMinutes: material ? parseFloat(material.materialMinutes) : 0,
        }

        if (onCostChange && material) {
            onCostChange(this.totalCost(), material.materialId)
        }
    }

    totalCost() {
        let { materialPrice } = this.state
        let total = materialPrice
        if (isNaN(total)) {
            total = 0
        }
        return total
    }

    componentDidMount() {
        let { material, materialId, network } = this.props

        if ((!material || !material.materialId) && materialId) {
            network.getMaterial(materialId)
        }
    }

    renderBalanceFooter() {
        return <Table.Row></Table.Row>
    }

    renderBalanceHeader() {
        return <Table.Header fullWidth></Table.Header>
    }

    renderForBalance() {
        return <Table.Row></Table.Row>
    }

    renderTableFooter() {
        let { isBalance } = this.props
        if (isBalance) return this.renderBalanceFooter()
        else return null
    }

    renderTableHeader() {
        let {
            onMaterialCodeHeaderClick,
            hideMaterial,
            hideMaterialName,
            hideMaterialUnitPrice,
            hideMaterialMeasurement,
            isBalance,
            hideActions,
            hideBarcode,
            onRowClick,
            sorts,
        } = this.props
        if (isBalance) {
            return this.renderBalanceHeader()
        } else {
            return (
                <Table.Header fullWidth>
                    <Table.Row>
                        {!hideMaterial && (
                            <Table.HeaderCell
                                {...(sorts ? { sorted: sorts.materialCode ? mapOrdToOrdering[sorts.materialCode] : null } : {})}
                                onClick={onMaterialCodeHeaderClick ? onMaterialCodeHeaderClick : () => {}}
                            >
                                Materiale
                            </Table.HeaderCell>
                        )}
                        {!hideMaterialName && <Table.HeaderCell>Descrizione</Table.HeaderCell>}
                        {!hideMaterialUnitPrice && <Table.HeaderCell>Prezzo per unità</Table.HeaderCell>}
                        {!hideMaterialMeasurement && <Table.HeaderCell>Unità di misura</Table.HeaderCell>}
                        {!hideBarcode && <Table.HeaderCell>Codice a barre</Table.HeaderCell>}
                        {!hideActions && <Table.HeaderCell>Azioni</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>
            )
        }
    }

    renderForTable() {
        let {
            hideMaterial,
            hideMaterialName,
            hideMaterialUnitPrice,
            hideMaterialMeasurement,
            hideBarcode,
            isBalance,
            onRowClick,
            hideActions,
        } = this.props
        let { materialId, materialCode, materialDescription, pricePerUnit, unit } = this.state

        setImmediate(() => {
            try {
                const text = materialCode
                JsBarcode(`#matbarcode${materialCode}`, text, {
                    format: 'CODE128',
                    // lineColor: '#0aa',
                    // width: 4,
                    // height: 40,
                    // displayValue: false,
                })
            } catch (e) {
                console.error(e)
            }
        })

        let scanned = this.props.scannedMaterials ? this.props.scannedMaterials.includes(materialCode) : false

        // console.log('Materiale is', scanned)
        if (isBalance) {
            return this.renderForBalance()
        } else {
            return (
                <Table.Row style={{ backgroundColor: scanned ? 'green' : 'white' }}>
                    {!hideMaterial && <Table.Cell>{materialCode}</Table.Cell>}
                    {!hideMaterialName && <Table.Cell>{materialDescription}</Table.Cell>}
                    {!hideMaterialUnitPrice && <Table.Cell>{pricePerUnit}</Table.Cell>}
                    {!hideMaterialMeasurement && <Table.Cell>{unit}</Table.Cell>}
                    {!hideBarcode && (
                        <Table.Cell>
                            <div className="barcode-container" ref={(el) => (this.componentRef = el)}>
                                <svg id={`matbarcode${materialCode}`}></svg>
                            </div>
                        </Table.Cell>
                    )}
                    {!hideActions && this.state.materialId && (
                        <Table.Cell className="no-print">
                            <SummarySheet type="material" objectToSerialize={this.state} />
                            <Button
                                icon
                                color="yellow"
                                onClick={(e) => {
                                    this.setState({
                                        mergingMaterial: true,
                                    })
                                    e.stopPropagation()
                                }}
                            >
                                <Icon name="exchange" />
                            </Button>
                            <Button
                                icon
                                color="blue"
                                onClick={(e) => {
                                    if (onRowClick) {
                                        onRowClick(this.state)
                                    }
                                    e.stopPropagation()
                                }}
                            >
                                <Icon name="edit" />
                            </Button>
                            <Button
                                icon
                                color="red"
                                onClick={(e) => {
                                    this.props.network.deleteMaterial({
                                        materialId,
                                        materialCode,
                                    })
                                    e.stopPropagation()
                                }}
                            >
                                <Icon name="remove" />
                            </Button>
                            <ReactToPrint
                                trigger={() => {
                                    return (
                                        <Button icon color="grey">
                                            <Icon name="print" />
                                        </Button>
                                    )
                                }}
                                content={() => this.componentRef}
                            />
                        </Table.Cell>
                    )}
                </Table.Row>
            )
        }
    }

    openRemoveDialog() {
        this.setState({ deleting: true })
    }

    remove() {
        let { network, material } = this.props

        network.deleteStdMaterial(material)

        this.setState({ deleting: false })
    }

    render() {
        let { mergeDestinations, mergingMaterial, materialId } = this.state
        let { login, type, material, onClick, selected, noActions } = this.props

        let extraprops = {
            fluid: type === 'full' ? true : false,
        }

        if (onClick) {
            extraprops.onClick = () => {
                onClick(material)
            }
        }

        let content = null
        switch (type) {
            case 'footer':
                content = this.renderTableFooter()
                break
            case 'header':
                content = this.renderTableHeader()
                break
            case 'table':
                content = this.renderForTable()
                break
            default:
                content = <Box borderWidth="1px" borderRadius="lg"
                    p="4" overflow="hidden" className={selected ? 'rowSelected' : ''} style={styles.materialCard} {...extraprops} />
                break
        }

        return (
            <>
                <Modal
                    key={`modal_material_${materialId}`}
                    closeIcon
                    open={!!mergingMaterial}
                    onClose={() => this.setState({ mergingMaterial: false })}
                >
                    <Modal.Header>Modificando materiale</Modal.Header>
                    <Modal.Content>
                        <MaterialDropdown
                            selected={mergeDestinations}
                            onChange={(ev, data, selected, materials) => {
                                this.setState({
                                    mergeDestinations: materials,
                                })
                            }}
                            onlySelection
                        />
                        <Button
                            style={{ marginTop: 16 }}
                            color="red"
                            onClick={() => {
                                this.props.network.mergeMaterial({
                                    sourceId: this.state.materialId,
                                    destinationId: this.state.mergeDestinations[0].materialId,
                                })
                                this.setState({ mergingMaterial: false })
                            }}
                            disabled={
                                !this.state.mergeDestinations ||
                                this.state.mergeDestinations.length !== 1 ||
                                this.state.materialId === this.state.mergeDestinations[0].materialId
                            }
                        >
                            Effettua unione AZIONE IRREVERSIBILE, VERRA{'\''} ELIMINATO IL MATERIALE {'"'}{this.state.materialDescription}{'"'} (
                            {this.state.materialId})
                        </Button>
                    </Modal.Content>
                </Modal>
                {content}
            </>
        )
    }
}

const styles = {
    header: {
        fontSize: '32pt',
        lineHeight: 'normal',
    },
    imageContainer: {
        minWidth: 200,
        minHeight: 150,
        marginRight: 28,
    },
    materialImage: {
        width: 200,
        height: 150,
        objectFit: 'contain',
    },
    materialContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    materialCard: {
        marginTop: 8,
        marginBottom: 8,
    },
}

const mapStateToProps = (state) => {
    let { login, getMaterial } = state
    let rmaterialId = null
    if (login && login.data && login.data.user) rmaterialId = login.data.user.rmaterialId

    return { role: rmaterialId, getMaterial, login }
}

export default withRouter(connect(mapStateToProps)(connectNetwork(Material)))
